module.exports = __webpack_public_path__ + "img/crypto-shib.e53ff3a9.svg";